// import * as ReactDOM from "react-dom";
// import { BrowserRouter } from "react-router-dom";

// import MainApp from "./pages"

// function App() {
//   return (
//     <BrowserRouter>
//       <MainApp />
//     </BrowserRouter>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter } from "react-router-dom";
// import ScriptLoader from "./components/ScriptLoader"; // Import the loader
import SetyScripts from "./utils/initScripts";
import { Provider } from "react-redux";
import MainApp from "./pages"
import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Slide, ToastContainer, toast } from 'react-toastify/unstyled';


function App({store, persistor}) {
  return (
    
    <Provider store={store}>
    <BrowserRouter>
      {/* ScriptLoader must be inside BrowserRouter */}
      <SetyScripts /> 
      <MainApp />
      <ToastContainer 
        // progressClassName="toastProgress"
        // className="toastBody"

        position="top-right"
        autoClose={4000}
        closeOnClick
        pauseOnHover
        // theme="dark" 
        // v11 uses these as the primary hooks
        toastClassName={(context) => 
          context?.defaultClassName + 
          " sety-tactical-toast " + 
          (context?.type === 'success' ? 'sety-success' : 'sety-error')
        }
      />
    </BrowserRouter>
    </Provider>
  );
}

export default App;